import * as ReactQuery from 'react-query';
import { InferMutationOptions } from 'services';
import { useIntl } from 'react-intl';
import { Store } from 'store';
import { acceptRegistrationViaExternalOidcAPI } from './api';

const ACCEPT_EXTERNAL_OIDC_REGISTRATION_KEY =
  '@site-employees/accept-external-oidc-registration';

export function useAcceptExternalOidcRegistration(
  options?: InferMutationOptions<
    typeof acceptRegistrationViaExternalOidcAPI,
    string
  >
) {
  const { showNotification } = Store.useNotifications();
  const intl = useIntl();

  const { mutate, isLoading } = ReactQuery.useMutation(
    ACCEPT_EXTERNAL_OIDC_REGISTRATION_KEY,
    acceptRegistrationViaExternalOidcAPI,
    {
      ...options,
      onError: (error, variables, context) => {
        showNotification({
          variant: 'error',
          description: intl.formatMessage({
            id: 'is.external_oidc_registration.accept_failed',
            defaultMessage:
              'Something went wrong. Please try again or contact support.',
          }),
        });

        if (options?.onError) {
          options.onError(error, variables, context);
        }
      },
    }
  );
  return {
    acceptRegistration: mutate,
    isLoading,
  };
}
